<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("CONTACTS.EDIT_CONTACT") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <contact-form
              :loading="loading"
              :contactData="contact"
              :formErrors="formErrors"
              @contactSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from "./partials/ContactForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultContact from "./defaultContact";

export default {
  layout: "DashboardLayout",

  components: { ContactForm },

  mixins: [alertLeave],

  data() {
    return {
      contact: cloneDeep(defaultContact),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("contacts/get", id);
        this.contact = this.$store.getters["contacts/contact"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Contacts" });
    },

    viewContact() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Contact",
        params: { id: this.contact.id },
      });
    },

    async handleSubmit(contact) {
      this.loading = true;
      const contactData = cloneDeep(contact);

      try {
        await this.$store.dispatch("contacts/update", contactData);
        this.$notify({
          type: "success",
          message: this.$t("CONTACTS.CONTACT_UPDATED"),
        });
        this.viewContact();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
